import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER, EnvironmentInjector } from '@angular/core';
import { patchAngularFirestoreInjectionContext } from './firestore-injection-context.patch';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { environment } from '../environments/environment';
//import { LoadingInterceptor } from './interceptors/httpInterceptor';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { providePrimeNG } from 'primeng/config';
import { PlanacanPreset } from './primeng-theme';
import { QuillModule } from 'ngx-quill'

import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';
import { ButtonsModule } from './buttons/buttons.module';
import { MaterialModule } from './app.material.module';
import { ColorPickerDirective } from 'ngx-color-picker';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import {GuidedTourModule, GuidedTourService} from 'ngx-guided-tour';
import { NgxCsvParserModule } from 'ngx-csv-parser';
import { NgxTippyModule } from 'ngx-tippy-wrapper';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

// firebase
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
// import { AngularFireAuthModule } from '@angular/fire/auth';
// import { AngularFireFunctionsModule } from '@angular/fire/functions';
// import { AngularFireStorageModule } from '@angular/fire/storage';
// import * as firebase from 'firebase';
// import { AngularFireAuthGuardModule } from '@angular/fire/auth-guard';
import { provideFirebaseApp, getApp, initializeApp } from '@angular/fire/app';
import { getFirestore, provideFirestore, connectFirestoreEmulator } from '@angular/fire/firestore';
import { getAuth, provideAuth, connectAuthEmulator } from '@angular/fire/auth';
import { getFunctions, provideFunctions, connectFunctionsEmulator } from '@angular/fire/functions';

import { NgxMaterialPopoverModule } from './modules/ngx-material-popover/ngx-material-popover.module';

import { AppComponent } from './app.component';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';

import { PagesModule } from './pages/pages.module';
//import { MarketingLayoutModule } from './layouts/marketing-layout/marketing-layout.module';
//import { MarketingLayoutComponent } from './layouts/marketing-layout/marketing-layout.component';
// import { CreateCompanyComponent } from './dialogs/create-company/create-company.component'

// import { GoogleChartComponent } from 'angular-google-charts';
import { TimelineHelper } from './components/timeline/timeline-helper';

import { ServiceModule } from './app.service.module';
import { GridModule } from './grid.module';

//dialogs
import {
  UserAddComponent,
  ForgotPasswordComponent,
  UpdateRoleComponent,
  HarvestAddComponent,
  EventUpdateComponent,
  EventRepeatComponent,
  HarvestEditComponent,
  TemplateAddComponent,
  EventAddComponent,
  UserSelectComponent,
  UserSelectSingleComponent,
  UserEditComponent,
  HarvestGroupDeleteComponent,
  HarvestSelectDialogComponent,
  HarvestSelectSingleDialogComponent,
  HarvestShiftComponent,
  UsersAssignComponent,
  RestrictionNotificationComponent,
  BlockNotificationComponent,
  DemoRequestComponent,
  ImageUploadComponent,
  FloorPlanUploadComponent,
  CreateCompanyComponent,
  HelpComponent,
  NotesComponent,
  UrlUploadDialogComponent,
  NotificationTokenComponent,
  TemplateUploadComponent,
  ZoneUpdateComponent,
  ZoneAssignComponent,
  ZoneExplanationDialogComponent,
  FilterCalendarDialogComponent,
  PostHarvestEditComponent,
  SensorEditComponent,
  SensorUploadComponent,
  EditRecurringEventsDialogComponent,
  DatePickerDialogComponent,
  SensorZoneTimelineDialogComponent,
  AttachmentUploadDialogComponent,
  AttachmentsSelectDialogComponent,
  DocumentationRedirectDialogComponent,
  InviteToOtherCompanyDialogComponent,
  LeaflogixHarvestMatchDialogComponent,
  FilterSetSaveDialogComponent,
  HarvestDocumentsDialogComponent,
  DocumentUploadDialogComponent,
  HarvestsReviewDialogComponent,
  ApplyWorkflowComponent,
  StrainUploadDialogComponent,
  CreateTeamsAlertDialogComponent,
  RoleAddDialogComponent,
  CompanySelectMultipleDialogComponent,
  CompanySelectDialogComponent,
  TemplateWorkflowDeleteComponent,
  EmbededVideoDialogComponent,
  ChangeColorDialogComponent,
  HarvestEditDialogComponent,
  DutchieUnmatchedBatchSelectDialogComponent,
  SubtasksDialogComponent,
  DescriptionDialogComponent,
  TemplatedTaskCreateFromStepDialogComponent,
  StepAddFromLibraryDialogComponent,
  EventAddFromLibraryDialogComponent,
  DataCollectionDefinitionsDialogComponent,
  DataSubmissionDialogComponent,
  DataInputDialogComponent,
  EventBulkUpdateDialogComponent,
  EventBulkEditAssignDialogComponent,
  TaskLibraryMigrateDialogComponent,
  TemplateMigrateDialogComponent,
  DataLibraryMigrateDialogComponent,
  TeamEditComponent
} from './dialogs';
import { SafePipe } from './services/pipes/safe.pipe';


//firebase.initializeApp(environment.firebase);

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    ButtonsModule,
    RouterModule,
    AppRoutingModule,
    // AgmCoreModule.forRoot({
    //   apiKey: 'YOUR_GOOGLE_MAPS_API_KEY'
    // }),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    // AngularFireAuthModule,
    // AngularFireFunctionsModule,
    // AngularFireStorageModule,
    // AngularFireAuthGuardModule,
    MaterialModule,
    ColorPickerDirective,
    NgxMatSelectSearchModule,
    PagesModule,
    //MarketingLayoutModule,
    ServiceModule,
    GridModule,
    GuidedTourModule,
    DragDropModule,
    NgxCsvParserModule,
    QuillModule.forRoot(),
    NgxTippyModule,
    NgxMaterialTimepickerModule
    // GoogleChartComponent,
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    UserAddComponent,
    ForgotPasswordComponent,
    UpdateRoleComponent,
    HarvestAddComponent,
    EventUpdateComponent,
    EventRepeatComponent,
    HarvestEditComponent,
    TemplateAddComponent,
    EventAddComponent,
    UserSelectComponent,
    UserSelectSingleComponent,
    UserEditComponent,
    HarvestGroupDeleteComponent,
    HarvestSelectDialogComponent,
    HarvestSelectSingleDialogComponent,
    HarvestShiftComponent,
    UsersAssignComponent,
    RestrictionNotificationComponent,
    BlockNotificationComponent,
    DemoRequestComponent,
    ImageUploadComponent,
    FloorPlanUploadComponent,
    CreateCompanyComponent,
    HelpComponent,
    NotesComponent,
    UrlUploadDialogComponent,
    NotificationTokenComponent,
    TemplateUploadComponent,
    ZoneUpdateComponent,
    ZoneAssignComponent,
    ZoneExplanationDialogComponent,
    FilterCalendarDialogComponent,
    PostHarvestEditComponent,
    SensorEditComponent,
    SensorUploadComponent,
    EditRecurringEventsDialogComponent,
    DatePickerDialogComponent,
    SensorZoneTimelineDialogComponent,
    AttachmentUploadDialogComponent,
    AttachmentsSelectDialogComponent,
    DocumentationRedirectDialogComponent,
    InviteToOtherCompanyDialogComponent,
    LeaflogixHarvestMatchDialogComponent,
    FilterSetSaveDialogComponent,
    HarvestDocumentsDialogComponent,
    DocumentUploadDialogComponent,
    HarvestsReviewDialogComponent,
    ApplyWorkflowComponent,
    StrainUploadDialogComponent,
    CreateTeamsAlertDialogComponent,
    RoleAddDialogComponent,
    CompanySelectMultipleDialogComponent,
    CompanySelectDialogComponent,
    TemplateWorkflowDeleteComponent,
    EmbededVideoDialogComponent,
    ChangeColorDialogComponent,
    HarvestEditDialogComponent,
    DutchieUnmatchedBatchSelectDialogComponent,
    SubtasksDialogComponent,
    DescriptionDialogComponent,
    TemplatedTaskCreateFromStepDialogComponent,
    StepAddFromLibraryDialogComponent,
    EventAddFromLibraryDialogComponent,
    DataCollectionDefinitionsDialogComponent,
    DataSubmissionDialogComponent,
    DataInputDialogComponent,
    EventBulkUpdateDialogComponent,
    EventBulkEditAssignDialogComponent,
    TaskLibraryMigrateDialogComponent,
    TemplateMigrateDialogComponent,
    DataLibraryMigrateDialogComponent,
    TeamEditComponent,
    SafePipe
  ],
  providers: [
    {
      // Make 'outline' the default Material form-field appearance app-wide.
      // The MDC migration defaults unset form fields to 'fill'; outline is the
      // intended look, so fields that don't specify an appearance use it.
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    providePrimeNG({
      theme: {
        preset: PlanacanPreset,
        options: {
          // Never auto-switch to dark mode for this spike.
          darkModeSelector: '.pc-primeng-dark-never',
          // Unlayered so PrimeNG's component styles compete normally with the
          // app's existing (unlayered) Bootstrap/Material CSS by specificity.
          cssLayer: false,
        },
      },
    }),
    {
      // Bridge for AngularFire v20 compat: ensure .collection()/.doc() reference
      // building runs in an injection context (see firestore-injection-context.patch.ts).
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: (injector: EnvironmentInjector) => () => patchAngularFirestoreInjectionContext(injector),
      deps: [EnvironmentInjector],
    },
    GuidedTourService,
    TimelineHelper,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => {
      const firestore = getFirestore();
      if ((environment as any).emulators?.firestore?.enabled) {
        connectFirestoreEmulator(firestore, 'localhost', (environment as any).emulators.firestore.port);
      }
      return firestore;
    }),
    provideAuth(() => {
      const auth = getAuth();
      if ((environment as any).useEmulators) {
        connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
      }
      return auth;
    }),
    provideFunctions(() => {
      const functions = getFunctions();
      if ((environment as any).emulators?.functions?.enabled) {
        connectFunctionsEmulator(functions, 'localhost', (environment as any).emulators.functions.port);
      }
      return functions;
    }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
